// context.js
import { createContext } from 'react';
export const SideBarContext = createContext(
   { pushSideBar:true, setPushSideBar: ()=>{}}
);

